import React from 'react';
import { render } from 'react-dom';
import { createMemoryHistory } from 'history';
import reportWebVitals from './reportWebVitals';
import App from './app/layout/App';
import { StoreContext, store } from './app/stores/store';
import { BrowserRouter } from 'react-router-dom';

export const history = createMemoryHistory();

const root = document.getElementById('root') as HTMLElement;

render(
  <StoreContext.Provider value={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StoreContext.Provider>,
  root,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more:
reportWebVitals();
